// Radio feedback in the player bar (contract D.4.2). WEB-CORE passes the
// playing QueueItem and forwards onVote(dir) to radioSource.vote(item, dir),
// which reweights the station; a thumbs down also skips the rest of that run.
//
// Props: { item, onVote(dir) }

import React, { useEffect, useState } from 'react';
import { IconThumbUp, IconThumbDown } from '../icons';
import './vibe.css';

export default function RadioThumbs({ item, onVote }) {
  const qid = item ? item.qid : null;
  const [voted, setVoted] = useState(0);

  useEffect(() => {
    setVoted(0);
  }, [qid]);

  if (!item) return null;

  const vote = (dir) => {
    setVoted(dir);
    onVote(dir);
  };

  return (
    <div className="vb-thumbs vb-root" role="group" aria-label="Steer the radio">
      <button
        type="button"
        className="icon-btn"
        title="More like this"
        aria-label="More like this"
        aria-pressed={voted > 0}
        onClick={() => vote(1)}
      >
        <IconThumbUp size={16} />
      </button>
      <button
        type="button"
        className="icon-btn"
        title="Less like this, skip ahead"
        aria-label="Less like this, skip ahead"
        aria-pressed={voted < 0}
        onClick={() => vote(-1)}
      >
        <IconThumbDown size={16} />
      </button>
    </div>
  );
}
